import { chipClasses, lighten } from "@mui/material";
function createChipFilledOutlineVariantStyles() {
  const colors = ["default", "primary", "secondary", "error", "warning", "success", "info"];
  return colors.flatMap((color) => {
    return [
      {
        props: { color, disabled: false, variant: "filledOutline" },
        style: ({ theme }) => {
          switch (color) {
            case "secondary": {
              const borderColor = theme.vars.palette.secondary.main;
              const deleteIconColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.54)`;
              const deleteIconHoverColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.87)`;
              return {
                "&:focus-within": {
                  backgroundColor: theme.vars.palette.secondary.main
                },
                "&:hover": {
                  backgroundColor: theme.vars.palette.secondary.main
                },
                backgroundColor: theme.vars.palette.secondary.light,
                border: `1px solid ${borderColor}`,
                color: theme.vars.palette.text.primary,
                [`& .${chipClasses.icon}`]: {
                  color: theme.vars.palette.action.active
                },
                [`& .${chipClasses.deleteIcon}`]: {
                  color: deleteIconColor
                },
                [`& .${chipClasses.deleteIcon}:hover`]: {
                  color: deleteIconHoverColor
                },
                [`& .${chipClasses.avatar}`]: {
                  backgroundColor: theme.vars.palette.common.white,
                  color: theme.vars.palette.text.primary
                }
              };
            }
            case "default":
            case void 0: {
              const borderColor = theme.vars.palette.action.active;
              const deleteIconColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.54)`;
              const deleteIconHoverColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.87)`;
              return {
                "&:focus-within": {
                  backgroundColor: theme.vars.palette.grey["400"]
                },
                "&:hover": {
                  backgroundColor: theme.vars.palette.grey["400"]
                },
                backgroundColor: theme.vars.palette.action.selected,
                border: `1px solid ${borderColor}`,
                color: theme.vars.palette.text.primary,
                [`& .${chipClasses.icon}`]: {
                  color: theme.vars.palette.action.active
                },
                [`& .${chipClasses.deleteIcon}`]: {
                  color: deleteIconColor
                },
                [`& .${chipClasses.deleteIcon}:hover`]: {
                  color: deleteIconHoverColor
                },
                [`& .${chipClasses.avatar}`]: {
                  backgroundColor: theme.vars.palette.common.white,
                  color: theme.vars.palette.text.primary
                }
              };
            }
            default: {
              const borderColor = theme.vars.palette[color].main;
              const deleteIconColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.54)`;
              const deleteIconHoverColor = `rgba(${theme.vars.palette.action.activeChannel} / 0.87)`;
              return {
                "&:focus-within": {
                  backgroundColor: lighten(theme.palette[color].main, 0.6)
                },
                "&:hover": {
                  backgroundColor: lighten(theme.palette[color].main, 0.6)
                },
                backgroundColor: lighten(theme.palette[color].main, 0.8),
                border: `1px solid ${borderColor}`,
                color: theme.vars.palette.text.primary,
                [`& .${chipClasses.icon}`]: {
                  color: theme.vars.palette.action.active
                },
                [`& .${chipClasses.deleteIcon}`]: {
                  color: deleteIconColor
                },
                [`& .${chipClasses.deleteIcon}:hover`]: {
                  color: deleteIconHoverColor
                },
                [`& .${chipClasses.avatar}`]: {
                  backgroundColor: theme.vars.palette.common.white,
                  color: theme.vars.palette.text.primary
                }
              };
            }
          }
        }
      },
      {
        // disabled style is always the same
        props: { color, disabled: true, variant: "filledOutline" },
        style: ({ theme }) => ({
          backgroundColor: theme.vars.palette.action.disabledBackground,
          borderColor: theme.vars.palette.action.disabled,
          color: theme.vars.palette.text.disabled
        })
      }
    ];
  });
}
export {
  createChipFilledOutlineVariantStyles
};
//# sourceMappingURL=chip.js.map
